import type { JSX } from 'react'
export const FeedsEmptyStateIllustration = (): JSX.Element => {
  return (
    <svg
      width="323"
      height="244"
      viewBox="0 0 323 244"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect width="323" height="222" rx="8.42105" fill="#EEF5EB" />
      <g filter="url(#filter0_ddd_2106_55288)">
        <rect
          x="56.3509"
          y="32.3499"
          width="162.105"
          height="131.228"
          rx="6.66667"
          fill="white"
        />
        <rect
          x="56.3509"
          y="32.3499"
          width="162.105"
          height="131.228"
          rx="6.66667"
          stroke="#213130"
          strokeWidth="0.701754"
        />
        <rect
          x="70.0352"
          y="44.6304"
          width="30.8772"
          height="30.8772"
          rx="15.4386"
          fill="#D9F1D1"
        />
        <path
          d="M80.7954 59.4842C82.1913 59.4842 83.53 60.0387 84.517 61.0257C85.504 62.0128 86.0586 63.3515 86.0586 64.7473M80.7954 55.3906C83.277 55.3906 85.6569 56.3764 87.4116 58.1311C89.1663 59.8859 90.1521 62.2658 90.1521 64.7473M81.965 64.1626C81.965 64.4855 81.7032 64.7473 81.3802 64.7473C81.0572 64.7473 80.7954 64.4855 80.7954 64.1626C80.7954 63.8396 81.0572 63.5778 81.3802 63.5778C81.7032 63.5778 81.965 63.8396 81.965 64.1626Z"
          stroke="#21201C"
          strokeWidth="1.05263"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="106.526"
          y="56.5601"
          width="98.2456"
          height="7.01754"
          rx="3.50877"
          fill="#EAE8E5"
        />
        <rect
          x="70.0352"
          y="82.5254"
          width="30.8772"
          height="30.8772"
          rx="15.4386"
          fill="#D9F1D1"
        />
        <rect
          x="70.0352"
          y="82.5254"
          width="30.8772"
          height="30.8772"
          rx="15.4386"
          fill="#D9F1D1"
        />
        <g clipPath="url(#clip0_2106_55288)">
          <path
            d="M80.7956 103.812H90.1523C90.4625 103.812 90.76 103.688 90.9793 103.469C91.1986 103.25 91.3219 102.952 91.3219 102.642L91.3219 93.2853C91.3219 92.9751 91.1987 92.6776 90.9793 92.4583C90.76 92.2389 90.4625 92.1157 90.1523 92.1157H83.1347C82.8246 92.1157 82.5271 92.2389 82.3077 92.4583C82.0884 92.6776 81.9652 92.9751 81.9652 93.2853L81.9651 102.642C81.9651 102.952 81.8419 103.25 81.6226 103.469C81.4032 103.688 81.1057 103.812 80.7956 103.812ZM80.7956 103.812C80.4854 103.812 80.1879 103.688 79.9685 103.469C79.7492 103.25 79.626 102.952 79.626 102.642L79.626 97.3789C79.626 96.7356 80.1523 96.2093 80.7956 96.2093H81.9652M88.9827 99.1333H84.3043M87.2283 101.472H84.3043M84.3043 94.4549H88.9827L88.9827 96.7941H84.3043L84.3043 94.4549Z"
            stroke="#21201C"
            strokeWidth="1.05263"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <rect
          x="106.526"
          y="94.4551"
          width="98.2456"
          height="7.01754"
          rx="3.50877"
          fill="#EAE8E5"
        />
        <rect
          x="70.0352"
          y="120.42"
          width="30.8772"
          height="30.8772"
          rx="15.4386"
          fill="#D9F1D1"
        />
        <rect
          x="70.0352"
          y="120.42"
          width="30.8772"
          height="30.8772"
          rx="15.4386"
          fill="#D9F1D1"
        />
        <g clipPath="url(#clip1_2106_55288)">
          <path
            d="M91.3219 135.858C91.3219 139.088 88.7037 141.706 85.4739 141.706M91.3219 135.858C91.3219 132.628 88.7037 130.01 85.4739 130.01M91.3219 135.858H79.626M85.4739 141.706C82.2442 141.706 79.626 139.088 79.626 135.858M85.4739 141.706C83.9723 140.129 83.1347 138.036 83.1347 135.858C83.1347 133.681 83.9723 131.587 85.4739 130.01M85.4739 141.706C86.9755 140.129 87.8131 138.036 87.8131 135.858C87.8131 133.681 86.9755 131.587 85.4739 130.01M79.626 135.858C79.626 132.628 82.2442 130.01 85.4739 130.01"
            stroke="#21201C"
            strokeWidth="1.05263"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <rect
          x="106.526"
          y="132.35"
          width="98.2456"
          height="7.01754"
          rx="3.50877"
          fill="#EAE8E5"
        />
      </g>
      <path
        d="M172.852 242.94C194.966 242.94 212.893 225.02 212.894 202.914L212.894 193.719C212.893 193.525 212.736 193.368 212.543 193.368C212.349 193.368 212.192 193.525 212.191 193.719L212.191 202.914C212.191 224.632 194.579 242.239 172.852 242.239C151.124 242.239 133.511 224.632 133.511 202.914L133.511 142.648C133.511 142.455 133.354 142.297 133.16 142.297C132.966 142.297 132.81 142.455 132.81 142.648L132.81 202.914C132.81 225.02 150.737 242.94 172.852 242.94Z"
        fill="#213130"
      />
      <rect
        x="155.351"
        y="149.394"
        width="130.298"
        height="44.2105"
        rx="5.26316"
        fill="#FFFFF9"
      />
      <rect
        x="155.351"
        y="149.394"
        width="130.298"
        height="44.2105"
        rx="5.26316"
        stroke="#213130"
        strokeWidth="0.701754"
      />
      <rect
        x="163"
        y="156.061"
        width="30.8772"
        height="30.8772"
        rx="15.4386"
        fill="#FFBB8A"
      />
      <rect
        x="163"
        y="156.061"
        width="30.8772"
        height="30.8772"
        rx="15.4386"
        fill="#FFD889"
      />
      <path
        d="M174.345 171.499H182.532M178.439 167.405L178.439 175.592"
        stroke="#21201C"
        strokeWidth="1.05263"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="199.491"
        y="167.999"
        width="73"
        height="7"
        rx="3.5"
        fill="#EAE8E5"
      />
      <path
        d="M119.609 156.096L133.173 142.453L146.698 156.096"
        stroke="#213130"
        strokeWidth="0.701754"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_ddd_2106_55288"
          x="44.7719"
          y="30.5955"
          width="185.263"
          height="155.789"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="5.61404"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2106_55288"
          />
          <feOffset dy="11.2281" />
          <feGaussianBlur stdDeviation="8.42105" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.129412 0 0 0 0 0.12549 0 0 0 0 0.109804 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2106_55288"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.80702"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_2106_55288"
          />
          <feOffset dy="2.80702" />
          <feGaussianBlur stdDeviation="2.80702" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.129412 0 0 0 0 0.12549 0 0 0 0 0.109804 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_2106_55288"
            result="effect2_dropShadow_2106_55288"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.701754"
            operator="dilate"
            in="SourceAlpha"
            result="effect3_dropShadow_2106_55288"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.350877" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.129412 0 0 0 0 0.12549 0 0 0 0 0.109804 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_2106_55288"
            result="effect3_dropShadow_2106_55288"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_2106_55288"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2106_55288">
          <rect
            width="14.0351"
            height="14.0351"
            fill="white"
            transform="matrix(1 0 -1.33795e-06 1 78.4563 90.9463)"
          />
        </clipPath>
        <clipPath id="clip1_2106_55288">
          <rect
            width="14.0351"
            height="14.0351"
            fill="white"
            transform="matrix(1 0 -1.35988e-06 1 78.4563 128.841)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
